export default {
  namespaced: true,
  actions: {
    create({ commit }, languageProficiency) {
      return Vue.$http.post('candidate/language_proficiencies', { languageProficiency })
    },
    destroy({ commit }, id) {
      return Vue.$http.delete(`candidate/language_proficiencies/${id}`)
    }
  }
}
